var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 62,
    viewBox: "0 0 45 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3298 20.6674C44.3508 20.451 44.7629 15.2964 42.5553 13.048C40.8018 11.2492 27.161 3.68909 21.3792 0.519997C20.3532 -0.0442456 18.5282 -0.247839 17.3677 0.413936L2.58306 9.14069C0.993588 10.0486 0.737086 11.631 0.699242 13.2049L0.0012206 43.2795C-0.0408289 45.3625 1.0062 47.2716 2.73444 48.2643L23.8096 60.4316C24.6044 60.894 25.4832 61.1231 26.3536 61.1189C27.2156 61.1189 28.0734 60.894 28.8556 60.4486L35.1251 57.4152L35.5162 27.2134C35.5288 26.2207 36.0755 25.3298 36.9501 24.8758L44.3087 20.8795L44.3256 20.6631L44.3298 20.6674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo-6.5235c1d67c094e2afe7f2f6e7f900179.svg";
export { ForwardRef as ReactComponent };